import { Tooltip } from '@modusign/design-system';
import { ReactElement } from 'react';

import GuideTooltipContent from '@app/containers/GlobalNavigationBar/GuideTooltip/GuideTooltipContent';
import useGNBGuideActive from '@app/hooks/useGNBGuideActive';

interface GuideTooltipProps {
  children: ReactElement;
  name: string;
  title: string;
  primaryBadges?: string[];
  secondaryBadges?: string[];
  video: string;
}

function GuideTooltip({
  children,
  name,
  title,
  primaryBadges,
  secondaryBadges,
  video,
}: GuideTooltipProps) {
  const isGuideActive = useGNBGuideActive();

  return (
    <Tooltip
      content={
        <GuideTooltipContent
          name={name}
          primaryBadges={primaryBadges}
          secondaryBadges={secondaryBadges}
          title={title}
          video={video}
        />
      }
      disabled={!isGuideActive}
      gutter={24}
      placement="right"
    >
      {children}
    </Tooltip>
  );
}

export default GuideTooltip;
